
import { getFocus, useAtom, useAtomValue, useGet }                 from 'state/jotai'
import { active_project, static_assets, vis_no_showOverviewPopup }           from 'state/store.global'
import { Backdrop }                from 'styles/styles.backdrop'
import { Icon }                    from 'assets/Icons_'

import { _project } from 'state/store.projects'
import { _bootstrap } from 'state/store.bootstrap'
import { useBreak } from 'hooks/useBreak'
import { PopupBox } from './OverviewPopupBox'
import { Box } from '@mui/material'
import { PoweredBy } from 'components/PoweredBy/PoweredBy'
import { CustomButton } from 'components/Unit/NewReservationButton'


export const OverviewPopup = ({}) => {

  const setOverviewPopup                = useAtom(vis_no_showOverviewPopup)[1];
  
  const { pin, pid } = useGet(active_project)
  
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []


  const close   = { icon: 'close', color: '#000', wrap: { position: 'absolute', top: 20, right: 20 }, size: '16', click: () => setOverviewPopup(false), }


  return (
    <div >
          <Backdrop  onClick  = {() => { setShare(false) }} />
        <PopupBox>
            <Box sx={{ p: 2 }}>
                <Icon {...close} />
                <img style={{ width: '80px', height: '100%', filter: 'invert(1)' }} src={'/soendrekyst/logos/logo_desktop.svg'} alt='logo' />
            </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 5 }}>
            <h1 style={{ textTransform: "uppercase" }}>NEPTUNUS</h1>
            <div style={{ height: 20 }} />
            <p className="paragraph1-regular" style={{ textAlign: 'start '}}>Ejendommen består af 104 lejeboliger.</p>
            <br />
            <p className="paragraph2-regular" style={{ width: '100%' }}>
                <ul style={{ listStyleType: 'disc', padding: '0px 0px 16px 16px', width: 'fit-content', margin: '0 auto' }}>
                    <li>58-124 m2</li>
                    <li>2-4 værelser.</li>
                    <li>Værkstedet Virkelyst</li>
                    <li>2 gæsteboliger</li>
                    <li>Erhvervslokaler til kontor, take-away <br /> eller mindre serviceerhverv.</li>
                  </ul>
            </p>
            <div style={{ height: 10 }} />
          </Box>
          <Box style={{ alignItems: "center", display: "flex", flexDirection: "column", px: "15px"}}>
            <div style={{ height: 0 }} />
             {/* <p className="paragraph2-regular" style={{ marginTop: "16px", marginBottom: "16px" }}>
                Udlejningen er ikke startet endnu
              </p> */}
              <CustomButton
                variant={"primary"}
                   onClick     = {() => window.open("https://soendrekyst.dk/fem-nye-ejendomme/neptunus/", "_self")}
                    clr = {clr}
                >
                    <span className = "eus-button-2">
                        Læs mere
                    </span>
                </CustomButton>
            <div style={{ height: 5 }} />
            <PoweredBy />
          </Box>
        </PopupBox>
    </div>
  )

}

